import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Button, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import PropTypes from "prop-types";
import AttachFile from "../../components/Comman/AttachFile";
import AutoComplete from "../../components/Comman/AutoComplete";
import BasicDatePicker from "../../components/Comman/DatePickerEx";
import * as React from "react";
import { connect } from "react-redux";
import { MyComponentWithIconProps } from "../../components/Comman/IconButton";
import { LabelCompo } from "../../components/Comman/Label";
import DynamicDetails from "../../components/dynamicscreens/DynamicDetails";
import { imageUrl } from "../../config/Url";
import { redColor, titleColor } from "../../config/ColorObj";
import dayjs from "dayjs";
import { downloadF } from "../PDF/PDFDownload";
import endpoint from "../../config/endpoints";
import { serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ExportPopUp = ({
    handleCloses,
    open,
    salesPersonList,
    showNotification,
    showLoador,
}) => {

    const [fromDate, setFromDate] = React.useState(dayjs());
    const [toDate, setToDate] = React.useState(dayjs());
    const [salesTeam, setSalesTeam] = React.useState("");
    const [formErrors, setFormErrors] = React.useState({});


    const handleClose = () => {
        handleCloses();
    };

    const changeDate = (name) => (date) => {
        if (name === "fromDate") {
            setFromDate(date)
        } else {
            setToDate(date)
        }
    };

    const onAutocompleteChange = () => (name, newValue) => {

        if (newValue != null) {
            setSalesTeam(newValue)
        }
    };


    const checkValidationOnSubmit = () => {
        let formError = {};
        let formIsValid = true;


        if (salesTeam === "" || salesTeam === null) {
            formIsValid = false;
            formError[`salesTeamError`] = "Select Sales Team";
        }

        setFormErrors(formError)
        return formIsValid;
    };



    const onExportHandler = async () => {

        if (checkValidationOnSubmit()) {

            let fromDateWithFormat = dayjs(fromDate).format("DD-MM-YYYY");
            let toDateWithFormat = dayjs(toDate).format("DD-MM-YYYY");

            let fromDateObj = dayjs(fromDateWithFormat, "DD-MM-YYYY");
            let toDateObj = dayjs(toDateWithFormat, "DD-MM-YYYY");

            let daysDifference = toDateObj.diff(fromDateObj, 'day');

            if (daysDifference !== null && daysDifference < 6) {
                showNotification({ msg: "Please select a duration of at least 7 days", severity: "error" });
                return;
            }

            showLoador({ loador: true });
            await downloadF({
                isGet: true,
                url: endpoint.exportData + "/date-wise-beat-by-sales-team?salesTeamId=" + salesTeam +
                    "&fromDate=" + dayjs(fromDate).format("DD-MM-YYYY") + "&toDate=" + dayjs(toDate).format("DD-MM-YYYY"),
                ext: "xls",
                openNewTab: false,
            }).then((response) => {
                showLoador({ loador: false });
                if (!response) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });
        }
    };


    return (
        <>
            <BootstrapDialog
                aria-labelledby="customized-dialog-title"
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        width: "70%",
                        borderRadius: "12px",
                    },
                }}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Export
                </BootstrapDialogTitle>
                <DialogContent
                    dividers
                    sx={{ backgroundColor: " #f7f8fa" }}
                >

                    <Grid
                        container
                        spacing={0}
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        display={'flex'}
                        justifyContent={'space-between'}
                    >
                        {/* From Date */}
                        <Grid item sm={6} xs={12} md={5} lg={5}>
                            <Grid container alignItems="center">
                                <Grid
                                    item
                                    style={{ display: "flex", alignItems: "center", marginRight: "33px" }}
                                >
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: redColor }}
                                        label="*"
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: titleColor, marginLeft: "2px" }}
                                        label="From date :"
                                    />
                                </Grid>

                                {/* Date Picker */}
                                <Grid item>
                                    <BasicDatePicker
                                        color="primary"
                                        name="fromDate"
                                        size="small"
                                        value={fromDate}
                                        disabled={false}
                                        onChange={changeDate("fromDate")}
                                        errorText=" "
                                        isError={false}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>


                        {/* To Date */}
                        <Grid item sm={6} xs={12} md={5} lg={5}>
                            <Grid container alignItems="center">
                                <Grid
                                    item
                                    style={{ display: "flex", alignItems: "center", marginRight: "33px" }}
                                >
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: redColor }}
                                        label="*"
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: titleColor, marginLeft: "2px" }}
                                        label="To date:"
                                    />
                                </Grid>
                                <Grid item>
                                    <BasicDatePicker
                                        color="primary"
                                        name="toDate"
                                        size="small"
                                        value={toDate}
                                        disabled={false}
                                        onChange={changeDate("toDate")}
                                        errorText=" "
                                        isError={false}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid
                        container
                        spacing={0}
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        display={'flex'}
                        justifyContent={'space-between'}
                    >
                        {/* First Field */}
                        <Grid item sm={6} xs={12} md={5} lg={5}>
                            <Grid container alignItems="center">
                                <Grid
                                    item
                                    style={{ display: "flex", alignItems: "center", marginRight: "33px" }}
                                >
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: redColor }}
                                        label="*"
                                    />
                                    <LabelCompo
                                        className="text-black"
                                        style={{ fontSize: 16, color: titleColor, marginLeft: "2px" }}
                                        label="Sales Team :"
                                    />
                                </Grid>

                                <Grid item>
                                    <AutoComplete
                                        name="salesTeam"
                                        label="Sales Team"
                                        placeHolder="Select Sales Team"
                                        keyColName="id"
                                        value={salesTeam}
                                        options={salesPersonList?.salesPersonByArea}
                                        onChange={onAutocompleteChange()}
                                        sx={{ width: "240px" }}
                                        isError={formErrors['salesTeamError'] ? formErrors['salesTeamError'] : ""}
                                        errorText={formErrors['salesTeamError'] ? formErrors['salesTeamError'] : ""}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                </DialogContent>


                <DialogContent dividers>
                    {/* Export */}
                    <Grid item sm={6} xs={12} md={6} lg={6}>
                        <Grid
                            container
                            alignItems="center"
                            spacing={2}
                            display="flex"
                            justifyContent="flex-end"
                        >
                            {/* Note text */}
                            <Box>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "14px",
                                        color: "#555",
                                        marginRight: 2,
                                        textAlign: "right", // first line right
                                        marginTop: 2,
                                    }}
                                >
                                    Select the From Date, To Date and Sales Team to export data.
                                </Typography>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: "14px",
                                        color: "#555",
                                        textAlign: "left", // second line left
                                        marginTop: 0.5,
                                    }}
                                >
                                    Select a duration of at least 7 days.
                                </Typography>
                            </Box>
                            {/* Export button */}
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                startIcon={<CloudDownloadIcon sx={{ color: "#fff" }} />}
                                sx={{
                                    borderRadius: 2,
                                    color: "#fff",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    transition: "all 0.2s",
                                    minWidth: "120px",
                                    height: "35px",
                                    marginTop: "18px",
                                    "&:hover": {
                                        backgroundColor: "#1976d2",
                                        transform: "translateY(-2px)",
                                    },
                                }}
                                onClick={onExportHandler}
                            >
                                Export
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>

            </BootstrapDialog>
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    showNotification,
    showLoador,
    showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportPopUp);
